import type { AnnotationSummaryJSONObject } from '@ikegps/core-api';
import { IkeRestDepartment } from '../rest.department';
import { IkeRestObject } from './base';

export class IkeObjectAnnotationSummary extends IkeRestObject<AnnotationSummaryJSONObject> {
	className = 'AnnotationSummary' as const;
	actionName = 'annotation.summary';
	object: AnnotationSummaryJSONObject;

	constructor() {
		super();
		this.cacheKeys['uuid'] = true;
		this.cacheKeys['revision'] = true;
		this.cacheKeys['collectionId'] = true;
	}

	override updateCache<K extends keyof AnnotationSummaryJSONObject>(
		key: K,
		result: AnnotationSummaryJSONObject,
		rest: IkeRestDepartment
	) {
		super.updateCache(key, result, rest);

		this.cacheIfLatest('uuid', result, rest);
		this.cacheIfLatest('revision', result, rest);
		this.cacheIfLatest('collectionId', result, rest);
	}
}
